import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatRentCents } from './format.js';
export const CTA_LABELS = {
    schedule: 'Schedule a showing',
    apply: 'Apply now',
};
export const CTA_CLASSES = {
    schedule: 'flex-1 py-3 px-3 sm:px-6 text-center text-sm sm:text-base font-semibold text-foreground bg-card border border-border rounded-lg min-h-[48px] flex items-center justify-center',
    apply: 'flex-1 py-3 px-3 sm:px-6 text-center text-sm sm:text-base font-semibold text-primary-foreground bg-primary rounded-lg min-h-[48px] flex items-center justify-center',
    /** Added to a live link. */
    live: 'focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
    /** Added to an inert button. */
    inert: 'cursor-not-allowed opacity-50',
};
export function ListingCtaBar({ rentCents, children }) {
    return (_jsx("div", { "data-testid": "listing-cta-bar", className: "sticky bottom-0 z-10 -mx-4 mt-6 bg-card/95 backdrop-blur border-t border-border px-4 py-3", children: _jsxs("div", { className: "w-full max-w-2xl mx-auto flex items-center gap-3", children: [_jsxs("div", { className: "shrink-0 pl-1", children: [_jsx("p", { className: "text-lg font-bold text-foreground leading-none font-serif", children: formatRentCents(rentCents) }), _jsx("p", { className: "text-xs text-muted-foreground mt-0.5", children: "/mo" })] }), children] }) }));
}
//# sourceMappingURL=ListingCtaBar.js.map